import { Injectable, OnDestroy } from '@angular/core';

import { BehaviorSubject, Observable, Subject, fromEvent } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class SidenavService implements OnDestroy {

  public get opened(): boolean {
    return this._opened$.value;
  }

  public set opened(value: boolean) {
    this._opened$.next(value);
  }

  public get opened$(): Observable<boolean> {
    return this._opened$.asObservable();
  }

  public mode: 'over' | 'push' | 'side';
  public topGap: number;
  public resize$: Observable<any>;

  public get changed$(): Observable<any> {
    return this._changed$.asObservable();
  }

  private _smallBreakpoint = 1023;
  private _destroy$ = new Subject();
  private _changed$ = new Subject();
  private _opened$ = new BehaviorSubject<boolean>(false);

  constructor() {
    this._updateSettings();

    this.resize$ = fromEvent(window, 'resize')
      .pipe(
        debounceTime(300),
      );

    this.resize$
      .pipe(
        takeUntil(this._destroy$),
      )
      .subscribe(() => {
        this._updateSettings();
      });
  }

  public toggle(): void {
    this.opened = !this.opened;
  }

  public changed(): void {
    this._changed$.next(null);
  }

  public open(): void {
    this.opened = true;
  }

  public close(): void {
    this.opened = false;
  }

  public hide(): void {
    if (window.innerWidth < this._smallBreakpoint) {
      this.opened = false;
    }
  }

  public ngOnDestroy(): void {
    this._destroy$.next(null);
    this._destroy$.complete();
  }

  private _updateSettings(): void {
    if (window.innerWidth < this._smallBreakpoint) {
      this.mode = 'over';
      this.topGap = 56;
      this.opened = false;
    } else {
      this.mode = 'side';
      this.opened = true;
      this.topGap = 0;
    }

    this.changed();
  }

}
